<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ !isUpdate ? $t('adicionar-campanha') : $t('campanha') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        $route.query.contexto == 'ven' ? $t('vendas') : $t('agro')
                                    }}</a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: 'ven-campanha' })">{{
                                        $t('campanhas')
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id ? $route.params.id : $t('novo')
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            v-if="this.$route.query.tela"
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="redirectToPage"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-else
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: 'ven-campanha' })"
                        >
                            {{ $t('voltar') }}
                        </button>

                        <button
                            v-if="
                                (!usuarioIntegracao && !isUpdate && permissao.create) ||
                                (!usuarioIntegracao && isUpdate && permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-2">
                            <v-input
                                :id="generateId(7)"
                                ref="idErpInput"
                                v-model="campanha.idcampanhaerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                :invalid="!campanha.idcampanhaerp"
                                tooltipLabel="cod-ref"
                                :disabled="usuarioIntegracao"
                            />
                        </div>
                        <div class="column is-6">
                            <v-input
                                :id="generateId(1)"
                                ref="descricaoInput"
                                v-model="campanha.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="descricao"
                                msg="msg-campo-obrigatorio"
                                :invalid="!campanha.descricao"
                                uppercase
                                required
                                tooltipLabel="info-descricao-generica"
                                :disabled="usuarioIntegracao"
                            />
                        </div>
                        <div class="column is-2">
                            <verified-date-picker
                                :id="generateId(2)"
                                v-model="date"
                                placeholder="selecione-uma-data"
                                title="data-validade"
                                :subtractDateYears="0"
                                :addDateYears="2"
                                :yearsRange="[-2, 10]"
                                :inForm="true"
                                :showToday="false"
                                :showClean="false"
                                required
                                tooltipLabel="info-data-validade-campanha"
                                :disabled="usuarioIntegracao"
                            />
                        </div>
                        <div class="column is-2">
                            <vss-select
                                :id="generateId(3)"
                                ref="situacaoSelect"
                                :searchable="false"
                                :options="situacoes"
                                v-model="situacao"
                                class="no-clear"
                                :mlLabels="true"
                                title="situacao"
                                :disabled="campanha.id == null || usuarioIntegracao"
                                tooltipLabel="info-situacao-generica"
                                tooltipPosition="is-left"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AssCampanhaClienteService from '@/services/vendas/cliente/abas/AssCampanhaClienteService';
import CampanhaService from '@/services/vendas/CampanhaService';
import CampanhaValidation from '@/services/validations/vendas/CampanhaValidation';
import Message from '@/models/Message';

export default {
    data() {
        return {
            assCampanhaClienteIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ASSCAMPANHACLIENTE'
            ),
            usuarioIntegracao: this.$store.state.user.tabelasERPWebServer.includes('CAMPANHA'),
            service: new CampanhaService(this.$http, this.$router),
            serviceAss: new AssCampanhaClienteService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            isSaving: false,
            validation: new CampanhaValidation(this.msgs),
            campanha: {
                idcampanha: null,
                idcampanhaerp: null,
                descricao: null,
                datavalidade: null,
                situacao: null,
            },
            isUpdate: false,
            date: new Date(this.$moment().add(1, 'days')),
            permissao: null,
            permissaoVincular: false,
            situacoes: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacao: { label: 'ativo', id: 1 },
        };
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;
        this.permissao = this.hasPermissionAccess('vendas', 'vendas', 'ven-campanha');
        this.permissaoVincular = this.permissao.create && !this.assCampanhaClienteIntegracao;
        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'campanha' },
            });
        } else {
            if (this.$route.params.id) {
                this.carregarDados(this.$route.params.id);
                this.isUpdate = true;
            }
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .find(id)
                .then((value) => {
                    this.campanha = value.content;
                    this.situacao = this.situacoes[this.campanha.situacao];
                    if (this.campanha.datavalidade != null)
                        this.date = this.$moment(this.campanha.datavalidade).toDate();
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        save() {
            this.isLoading = true;

            if (this.validation.validate(this.campanha, this.$refs)) {
                let campanhaTemp = Object.assign({}, this.campanha);
                campanhaTemp = this.mapTosave(campanhaTemp);
                campanhaTemp.situacao = this.situacao.id;
                campanhaTemp.datavalidade =
                    this.date != null ? this.$moment(this.date).format('YYYY-MM-DD') : null;

                this.invalidIcon = false;
                this.isSaving = true;

                this.service
                    .save(campanhaTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg =
                                this.campanha.idcampanha != null
                                    ? 'msg-edit-campanha'
                                    : 'msg-save-campanha';
                            this.msgs.push(new Message('success', msg, true));
                            // @85242
                            if (
                                this.permissaoVincular &&
                                !this.isUpdate &&
                                this.$route.query.tela == 'ven-cliente-campanha'
                            ) {
                                this.promptConfirmaVinculo(value.content);
                            } else {
                                this.redirectToPage();
                            }
                        } else {
                            if (this.$te(value.message)) {
                                this.msgs.push(new Message('alert', value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        let message = e.body.message;
                        if (message && this.$te(message)) {
                            if (message == 'msg-codigo-duplicado-n') {
                                this.msgs.push(
                                    new Message(
                                        'alert',
                                        this.$t(message, { n: campanhaTemp.idcampanhaerp }),
                                        true,
                                        false
                                    )
                                );
                            } else {
                                this.msgs.push(new Message('alert', message, true));
                            }

                            return;
                        }

                        this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
                this.isSaving = false;
            }
        },
        // @85242
        promptConfirmaVinculo(vinculo) {
            this.$root.confirm({
                message: this.$t('deseja-realizar-vinculo'),
                onConfirm: (_) => {
                    this.realizarVinculo(vinculo);
                },
                onCancel: (_) => {
                    this.redirectToPage();
                },
            });
        },
        // @85242
        realizarVinculo(vinculo) {
            this.isLoading = true;
            this.isLoadingEdit = true;

            this.campanha.datavalidade = vinculo.datavalidade;
            this.campanha.idcampanha = vinculo.idcampanha;
            this.campanha.situacao = vinculo.situacao;

            let clienteCampanhaTemp = {
                campanha: this.campanha,
                idcampanha: this.campanha.idcampanha,
                idcliente: this.$route.query['id'],
            };

            this.saveAssCampanha(clienteCampanhaTemp)
                .then((value) => {
                    if (value.message == null) {
                        this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
                        this.redirectToPage();
                    } else {
                        if (this.$t(value.message)) {
                            this.msgs.push(new Message('alert', value.message, true));
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message('alert', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                    this.isLoadingEdit = false;
                });
        },
        saveAssCampanha() {
            if (this.isVenda) return this.serviceAss.saveVendas(this.campanhaSelecionados);
            else return this.serviceAss.saveAgro(this.campanhaSelecionados);
        },
        redirectToPage() {
            //função para redirecionar para uma aba de uma tela especificada abaixo
            let tempTela = null;
            let tempAba = null;
            if (this.$route.query.tela == 'cliente-campanha') {
                tempTela = `${this.$route.query.contexto}-cliente-politica-comercial-edit`;
                setTimeout(() => {
                    this.$router.push({
                        name: tempTela,
                        params: { id: this.$route.query['id'] },
                        query: {
                            dadoscadastrais: this.$route.query.dadoscadastrais,
                            politicacomercial: this.$route.query.politicacomercial,
                            analisecomercial: this.$route.query.analisecomercial,
                        },
                    });
                }, 1000);
            } else {
                if (this.$route.query.tela == 'usuario-campanha') {
                    tempTela = 'usuario-gerenciar-edit';
                    tempAba = 'campanha';
                } else {
                    tempTela = 'ven-campanha';
                }
                setTimeout(
                    () => {
                        this.$router.push({
                            name: tempTela,
                            params: { id: this.$route.query['id'] },
                            query: { abaSelecionada: tempAba },
                        });
                    },
                    tempAba != null ? 0 : 1000
                );
            }
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
